import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import { CloseModalButton } from "components/Button/CloseModalButton";
import TimelineLogs from "components/TimelineLogs";
import useLogsOrcamento from 'core/features/orcamento/hooks/useLogsOrcamento';

interface ModalHistoryOrcamentoProps {
  orcamentoId?: string;
  isOpenModal: boolean;
  onClose: () => any;
}

export default function ModalHistoryOrcamento({
  orcamentoId,
  isOpenModal,
  onClose,
}: ModalHistoryOrcamentoProps) {
  const { data, isFetching } = useLogsOrcamento(orcamentoId);

  console.log('logs',data)

  useLoading(isFetching);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="500px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <CloseModalButton
              showBorder={false}
              close={onClose}
              closeModalLabel="Fechar"
            />
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex>
          <Heading mb={4} size="md">
            Histórico
          </Heading>
        </Flex>
        <Flex py="4px" flexDir={"column"}>
          {data?.map((item, key) => (
            <TimelineLogs key={key} data={item} />
          ))}
        </Flex>
      </Modal>
    </>
  );
}
